import { Icon } from '@shared/src/lib/components/icon/icon.interface';
import { SideNavigation } from '@shared/src/lib/components/side-navigation/side-navigation.interface';
import { USER_ROLE_ENUM } from '@shared/src/models/user-role.enum';

export type UserRole = (typeof USER_ROLE_ENUM)[keyof typeof USER_ROLE_ENUM];

export interface NavigationAccess {
  'adir': boolean;
  'fdp': boolean;
  'historical-milestone-review': boolean;
  'user-management': boolean;
  'settings': boolean;
  'action-items-tracker': boolean;
}

export type NavigationMap = Record<UserRole, NavigationAccess>;

export const NAVIGATION_ACCESS_MAP: NavigationMap = {
  [USER_ROLE_ENUM.TRC_SECRETARIAT]: {
    'adir': true,
    'fdp': true,
    'historical-milestone-review': true,
    'user-management': true,
    'settings': false,
    'action-items-tracker': true,
  },
  [USER_ROLE_ENUM.ASSET_MANAGER]: {
    'adir': true,
    'fdp': true,
    'historical-milestone-review': true,
    'user-management': true,
    'settings': false,
    'action-items-tracker': true,
  },
  [USER_ROLE_ENUM.TRC_LEAD]: {
    'adir': true,
    'fdp': true,
    'historical-milestone-review': true,
    'user-management': false,
    'settings': false,
    'action-items-tracker': true,
  },
  [USER_ROLE_ENUM.TRC_REVIEWER]: {
    'adir': true,
    'fdp': true,
    'historical-milestone-review': true,
    'user-management': false,
    'settings': false,
    'action-items-tracker': true,
  },
  [USER_ROLE_ENUM.CLUSTER_HEAD]: {
    'adir': true,
    'fdp': true,
    'historical-milestone-review': true,
    'user-management': false,
    'settings': false,
    'action-items-tracker': true,
  },
  [USER_ROLE_ENUM.RESOURCE_PERSON]: {
    'adir': true,
    'fdp': true,
    'historical-milestone-review': true,
    'user-management': false,
    'settings': false,
    'action-items-tracker': true,
  },
  [USER_ROLE_ENUM.APPROVER]: {
    'adir': true,
    'fdp': true,
    'historical-milestone-review': true,
    'user-management': false,
    'settings': false,
    'action-items-tracker': true,
  },
  [USER_ROLE_ENUM.FDP_APPROVER]: {
    'adir': true,
    'fdp': true,
    'historical-milestone-review': true,
    'user-management': false,
    'settings': false,
    'action-items-tracker': true,
  },
  [USER_ROLE_ENUM.PAC_REP]: {
    'adir': true,
    'fdp': true,
    'historical-milestone-review': true,
    'user-management': false,
    'settings': false,
    'action-items-tracker': true,
  },
  [USER_ROLE_ENUM.PAC_REVIEWER]: {
    'adir': true,
    'fdp': true,
    'historical-milestone-review': true,
    'user-management': false,
    'settings': false,
    'action-items-tracker': true,
  },
  [USER_ROLE_ENUM.TRC_MEMBER]: {
    'adir': true,
    'fdp': true,
    'historical-milestone-review': true,
    'user-management': false,
    'settings': false,
    'action-items-tracker': true,
  },
  [USER_ROLE_ENUM.WELL_MANAGEMENT]: {
    'adir': true,
    'fdp': true,
    'historical-milestone-review': true,
    'user-management': false,
    'settings': false,
    'action-items-tracker': true,
  },
  [USER_ROLE_ENUM.TECHNICAL_PROFESSIONAL]: {
    'adir': true,
    'fdp': true,
    'historical-milestone-review': true,
    'user-management': false,
    'settings': false,
    'action-items-tracker': true,
  },
} as const;

export const SIDE_NAVIGATION_ITEMS: SideNavigation.Item[] = [
  {
    path: 'adir',
    icon: Icon.Names.Clipboard,
    label: 'ADIR',
    isVisible: false,
  },
  {
    path: 'fdp',
    icon: Icon.Names.Clipboard,
    label: 'FDP',
    isVisible: false,
  },
  {
    path: 'historical-milestone-review',
    icon: Icon.Names.HistoricalMr,
    label: 'Historical MR',
    isVisible: false,
  },
  {
    path: 'user-management',
    icon: Icon.Names.UserManagement,
    label: 'User Management',
    isVisible: false,
  },
  {
    path: 'settings',
    icon: Icon.Names.Settings,
    label: 'Settings',
    isVisible: false,
  },
] as const;

export function isValidUserRole(role: string): role is UserRole {
  return Object.values(USER_ROLE_ENUM).includes(role as UserRole);
}
